import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import React from 'react';
import FileUploadNewCallStore from 'stores/file-upload/FileUploadNewCallStore';
import FileUploadNewCallDialog from './FileUploadNewCallDialog';

/**
 * `FileUploadNewCallDialogContainer` links <FileUploadNewCallDialog /> with `FileUploadNewCallStore`
 * so that we can keep track of the file upload progress
 */
class FileUploadNewCallDialogContainer extends React.Component {
  static getStores() {
    return [FileUploadNewCallStore];
  }

  static getPropsFromStores() {
    return FileUploadNewCallStore.getState().toObject();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.closeNewCallDialog) {
      setTimeout(() => {
        this.props.handleCloseNewCallDialog();
      }, 1000);
    }
  }

  render() {
    return (
      <AltContainer>
        <FileUploadNewCallDialog {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(FileUploadNewCallDialogContainer);
